module.exports = __webpack_public_path__ + "static/img/h-i-7.a66416b2.png";